import axios from 'axios';

// Get All users
function getAllUsersApi() {
    return axios({
        method: 'get',
        url: '/api/v1/users'
    });
}

export {
    getAllUsersApi
}
